import { motion } from 'framer-motion';
import { Check, RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Task } from '@/types/task';
import { cn } from '@/lib/utils';

interface CompletedTaskItemProps {
  task: Task;
  onRevive: (id: string) => void;
}

export function CompletedTaskItem({ task, onRevive }: CompletedTaskItemProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      className={cn(
        "group flex items-center gap-3 p-3 rounded-xl",
        "bg-muted/30 border border-border/30"
      )}
    >
      {/* Completed checkmark */}
      <div className="w-5 h-5 rounded-full bg-success/20 flex items-center justify-center flex-shrink-0">
        <Check className="h-3 w-3 text-success" />
      </div>

      {/* Task content */}
      <div className="flex-1 min-w-0">
        <p className="text-sm text-muted-foreground line-through truncate">
          {task.content}
        </p>
        {task.duration && (
          <p className="text-xs text-muted-foreground/60 mt-0.5">
            {task.duration} min
          </p>
        )}
      </div>

      {/* Revive button - always visible */}
      <Button
        variant="secondary"
        size="sm"
        onClick={() => onRevive(task.id)}
        className="gap-1.5"
      >
        <RotateCcw className="h-3.5 w-3.5" />
        <span className="text-xs">Revive</span>
      </Button>
    </motion.div>
  );
}
